const DEFAULT_BUSINESS_TIMEZONE = "Europe/Rome";
const LOCAL_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

const getZonedParts = (value, timeZone) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  return Object.fromEntries(parts.map((part) => [part.type, part.value]));
};

export const toBusinessDateTimeLocalValue = (
  value,
  timeZone = DEFAULT_BUSINESS_TIMEZONE
) => {
  const parts = getZonedParts(value, timeZone);
  if (!parts) return "";
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const isHistoricalAppointmentEnd = ({
  endTime,
  now = new Date(),
  timeZone = DEFAULT_BUSINESS_TIMEZONE,
}) => {
  const normalizedEnd = String(endTime || "").slice(0, 16);
  if (!LOCAL_DATE_TIME_PATTERN.test(normalizedEnd)) return false;
  const businessNow = toBusinessDateTimeLocalValue(now, timeZone);
  return Boolean(businessNow) && normalizedEnd <= businessNow;
};

export const businessLocalDateTimeToIso = (
  value,
  timeZone = DEFAULT_BUSINESS_TIMEZONE
) => {
  const normalized = String(value || "").slice(0, 16);
  if (!LOCAL_DATE_TIME_PATTERN.test(normalized)) return null;
  const [datePart, timePart] = normalized.split("T");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":").map(Number);
  const wallTimeUtc = Date.UTC(year, month - 1, day, hour, minute, 0, 0);

  let candidateMs = wallTimeUtc;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const parts = getZonedParts(new Date(candidateMs), timeZone);
    if (!parts) return null;
    const representedWallTime = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );
    const adjustment = wallTimeUtc - representedWallTime;
    candidateMs += adjustment;
    if (adjustment === 0) break;
  }

  if (toBusinessDateTimeLocalValue(new Date(candidateMs), timeZone) !== normalized) {
    return null;
  }
  return new Date(candidateMs).toISOString();
};

